import { render, staticRenderFns } from "./OrmMessageNew.vue?vue&type=template&id=4ff93b6b"
import script from "./OrmMessageNew.vue?vue&type=script&lang=js"
export * from "./OrmMessageNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ff93b6b')) {
      api.createRecord('4ff93b6b', component.options)
    } else {
      api.reload('4ff93b6b', component.options)
    }
    module.hot.accept("./OrmMessageNew.vue?vue&type=template&id=4ff93b6b", function () {
      api.rerender('4ff93b6b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ormmessage/OrmMessageNew.vue"
export default component.exports